export default [
    {
        path: '/heishop/inventarios',
        name: 'heishop-inventarios',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/Inventario.vue')
    },

]